var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwardSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87451 22.9583V33.3124C8.87451 37.1041 8.87451 37.1041 12.4578 39.5208L22.3121 45.2082C23.7912 46.0624 26.2079 46.0624 27.6871 45.2082L37.5412 39.5208C41.1246 37.1041 41.1246 37.1041 41.1246 33.3124V22.9583C41.1246 19.1667 41.1246 19.1667 37.5412 16.75L27.6871 11.0625C26.2079 10.2083 23.7912 10.2083 22.3121 11.0625L12.4578 16.75C8.87451 19.1667 8.87451 19.1667 8.87451 22.9583Z",
    stroke: "#2D3B36",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.4583 15.8957V10.4165C36.4583 6.24984 34.375 4.1665 30.2083 4.1665H19.7916C15.625 4.1665 13.5416 6.24984 13.5416 10.4165V15.7498",
    stroke: "#2D3B36",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.3121 22.896L27.4996 24.7502C27.6871 25.0418 28.1038 25.3335 28.4163 25.4168L30.5413 25.9585C31.8538 26.2918 32.208 27.4168 31.3538 28.4585L29.958 30.146C29.7496 30.4168 29.583 30.896 29.6038 31.2293L29.7288 33.4168C29.8121 34.771 28.8538 35.4585 27.6038 34.9585L25.5621 34.146C25.2496 34.021 24.7288 34.021 24.4163 34.146L22.3746 34.9585C21.1246 35.4585 20.1662 34.7502 20.2496 33.4168L20.3746 31.2293C20.3954 30.896 20.2287 30.396 20.0204 30.146L18.6246 28.4585C17.7704 27.4168 18.1246 26.2918 19.4371 25.9585L21.5621 25.4168C21.8955 25.3335 22.3121 25.021 22.4788 24.7502L23.6663 22.896C24.4163 21.771 25.583 21.771 26.3121 22.896Z",
    stroke: "#2D3B36",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardSvgrepoCom1);
export default __webpack_public_path__ + "static/media/award-svgrepo-com 1.8d0271b4a6fb251904ce4f75f487f63e.svg";
export { ForwardRef as ReactComponent };